import { useCallback } from 'react';
import * as dateUtils from 'js/utils/date.util';
import { useFormatter } from 'js/hooks/useFormatter';

import * as Types from './types';
import * as helpers from './helpers';

export const useUpdateTickerValue = () => {
    const formatter = useFormatter();

    return useCallback((
        { enableHitTime, interval, jackpotRef, tickerData }: Types.IUpdateTickerValueParams
    ): void => {
        if (!tickerData) {
            return;
        }

        const date = Date.now();
        const newTickerData = {
            ...helpers.getAmount({ date, tickerData, interval }),
            ...helpers.getCountdownTimer({ date, tickerData })
        };

        if (jackpotRef.current && Object.keys(newTickerData).length) {
            Object.assign(tickerData, newTickerData);

            jackpotRef.current.textContent = enableHitTime && tickerData.showHitTime
                ? dateUtils.getTime(tickerData.hitTime)
                : formatter.formatCurrency(tickerData.amount, tickerData);
        }
    }, [formatter]);
};
